import React from "react";
import { Box, Divider } from "@mui/material";

import LoadingWrapper from "./LoadingWrapper";

export const AppForm = ({ children, loading = false }) => {
  return <LoadingWrapper loading={loading}>{children}</LoadingWrapper>;
};

export default AppForm;

AppForm.Content = ({ children, disablePadding = false }) => {
  return <Box padding={!disablePadding && 3}>{children}</Box>;
};

AppForm.Actions = ({ children }) => {
  return (
    <>
      <Divider />

      <Box
        display="flex"
        justifyContent="flex-end"
        gap={2}
        paddingX={3}
        paddingY={2}
      >
        {children}
      </Box>
    </>
  );
};
